export default __webpack_public_path__ + "static/media/5.0aa61c0c.jpg";